import { Outlet } from "react-router-dom";
import Menu from "../../Components/Menu/Menu";
import Banner from "../../Components/Banner/Banner";
import Footer from "../../Components/Footer/Footer";
import "./AppLayout.css";

const AppLayout = () => {
  return (
    <div className="app-layout">
      <Menu />
      <Banner />

      <main className="app-layout-content">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default AppLayout;
